import { type Registry as Services, service } from '@ember/service';
import { cached } from '@glimmer/tracking';
import type Transition from '@ember/routing/transition';
import ProtectedRoute from 'uplisting-frontend/pods/base/protected-route';

const PERMISSIONS = [
  'dashboard.index',
  'advanced_report_configurations.index',
  'disputes.index',
  'automate.identity',
];

export default class ProtectionRoute extends ProtectedRoute {
  @service features!: Services['features'];

  @cached
  get isPermitted(): boolean {
    return (
      this.features.isProtectionGateEnabled &&
      PERMISSIONS.some((permission) => this.currentUser.hasAccessTo(permission))
    );
  }

  async beforeModel(transition: Transition): Promise<void> {
    await super.beforeModel(transition);

    if (!this.isPermitted) {
      transition.abort();

      this.router.transitionTo('index');
    }
  }
}
